import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {take} from 'rxjs/operators';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'app-audit-tracker-magic-link',
  templateUrl: './audit-tracker-magic-link.component.html',
  styleUrls: ['./audit-tracker-magic-link.component.css']
})
export class AuditTrackerMagicLinkComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
              private commandService: CommandService,
              private router: Router,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe( params => {
      let command = new PlatformCommand('NavigateToCaseCommand', 'AuditTrackerApi');
      if (params['caseId']) {
        command.fieldValues['AuditTrackerId'] = params['caseId'];
      }
      if (params['recordId']) {
        command.fieldValues['AuditStageRecordId'] = params['recordId'];
      }
      command.projectId = '[PROJECT_ID]';
      this.executeCommand(command);
    });
  }

  executeCommand(command) {
    this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        console.log('[PlatformFilterHandler] Command Response', commandResponse);
        this.fuseSplashScreenService.hide();
        if (commandResponse.fieldValues['RedirectCommand']) {
          this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
        }

        if (commandResponse.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
        }
        if (commandResponse.fieldValues['SnackBarMessage']) {
          const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
          this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
        }
      }, () => {
        this.fuseSplashScreenService.hide();
      });
  }
}
